import { createInputUrlStore } from "../utils/createInputUrlStore.ts";

export const modelUuidsInputUrlStore = createInputUrlStore<string[]>(
  "modelUuids",
  (value) => (value ? value.join(",") : ""),
  (value) => (value ? value.split(",") : undefined),
);
